import { RoleTypes } from '../../constants/role-types.constant';
import {
  LanguageSubMenuItem,
  ProfileDropdownItem,
  ProfileDropdownSubItem,
} from './profile-dropdown.model';

export const PROFILE_DROPDOWN_MENU_ITEMS: ProfileDropdownItem[] = [
  {
    slug: 'workspace',
    mainText: 'profile_dropdown_menu_workspace_settings_label',
    hasSubMenu: true,
  },
  {
    slug: 'create_workspace',
    mainText: 'profile_dropdown_menu_create_workspace_label',
  },
  {
    slug: 'portal',
    mainText: 'profile_dropdown_menu_portal_settings_label',
    hasSubMenu: true,
  },
  {
    slug: 'language',
    mainText: 'profile_dropdown_menu_language_label',
    hasSubMenu: true,
  },
  {
    slug: 'logout',
    mainText: 'sidenav_sign_out_item_label',
    itemClass: 'text-destructive-500',
  },
];

export const ProfileDropdownItemSlugs = {
  WORKSPACE: 'workspace',
  CREATE_WORKSPACE: 'create_workspace',
  PORTAL: 'portal',
  LANGUAGE: 'language',
  LOGOUT: 'logout',
} as const;

export const PORTAL_SUB_MENU_ITEMS: ProfileDropdownSubItem[] = [
  {
    slug: RoleTypes.EMPLOYEE,
    mainText: 'profile_dropdown_menu_employee_portal_label',
    isMainTextTranslatable: true,
    showImage: true,
    img: {
      url: '',
      id: 0,
      name: '',
      mime_type: '',
      order: 0,
    },
  },
  {
    slug: RoleTypes.VENDOR,
    mainText: 'profile_dropdown_menu_vendor_portal_label',
    isMainTextTranslatable: true,
    showImage: true,
    img: {
      url: '',
      id: 0,
      name: '',
      mime_type: '',
      order: 0,
    },
  },
];

export const LanguageSubMenuItems: LanguageSubMenuItem[] = [
  {
    slug: 'en',
    mainText: 'navbar_language_dropdown_en',
    itemClass: 'font-main-en rtl:text-xs2',
    isSelected: true,
    isMainTextTranslatable: true,
  },
  {
    slug: 'ar',
    mainText: 'navbar_language_dropdown_ar',
    itemClass: 'font-main-ar ltr:text-lg',
    isMainTextTranslatable: true,
  },
];
